import { IRegionsWithCitiesGroup } from '@r1-frontend/api-domru/api-content/v1/geography/get-regions/dto/ResponseDto';

import { IAction } from '~/src/store';

import { ECitySelect } from './index';

export type TSetRegions = IAction<ECitySelect.SET_REGIONS, IRegionsWithCitiesGroup>

const setRegions = (regions: IRegionsWithCitiesGroup): TSetRegions => ({
    type: ECitySelect.SET_REGIONS,
    payload: regions,
});

export default setRegions;
